import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styles from './MarkdownSection.module.scss'

/**
 * Pre-process text so unicode bullets (•) become markdown list items.
 * Handles bullets at line start and mid-string (space-then-bullet).
 */
export const preprocessMarkdown = (text) => {
    if (!text) return text
    // Split concatenated bullets into separate lines first
    let result = text.replace(/ [•\u2022] /g, '\n- ')
    // Then convert any remaining leading bullets
    result = result.replace(/^[•\u2022] /gm, '- ')
    return result
}

export const MarkdownSection = ({ content, className = '' }) => {
    if (!content) return null

    const processed = preprocessMarkdown(content)

    return (
        <div className={`${styles.markdownContent} ${className}`}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{processed}</ReactMarkdown>
        </div>
    )
}
